const LANGUAGES_DATA = [
	{
		code: "en",
		name: "English",
		nativeName: "English",
		flag: "https://flagcdn.com/gb.svg",
	},
	{
		code: "th",
		name: "Thai",
		nativeName: "ไทย",
		flag: "https://flagcdn.com/th.svg",
	},
	{
		code: "zh",
		name: "Chinese",
		nativeName: "中文",
		flag: "https://flagcdn.com/cn.svg",
		beta: true,
	},
	{
		code: "ru",
		name: "Russian",
		nativeName: "Русский",
		flag: "https://flagcdn.com/ru.svg",
		beta: true,
	},
] as const;

export type Locale = (typeof LANGUAGES_DATA)[number]["code"];

export type Language = {
	code: Locale;
	name: string;
	nativeName: string;
	flag: string;
	beta?: boolean;
};

export const LANGUAGES: readonly Language[] = LANGUAGES_DATA;

export const SUPPORTED_LOCALES: readonly Locale[] = LANGUAGES_DATA.map(
	(l) => l.code,
);
